<template>
  <div class="panel mr-20 w-full p-6 rounded border bg-blue-lightest">
    <div class="w-full flex items-start">
      <div class="w-full flex flex-col mr-8">
        <div class="flex inline-block">
          <h2
            class="text-xl mb-3 font-bold font-medium uppercase pr-8"
          >Call to action</h2>
          <!-- <input id="callToaction" type="checkbox" class="blue" :value="song" v-model="options" /> -->
          <!-- <label for="callToaction" class="ml-8 mt-1 text-xs font-semibold">Display</label> -->
        </div>
        <div class="w-full flex flex-col mb-5 mt-1">
          <label class="text-xs uppercase mb-2">Contact Name:</label>
          <input
            readonly
            v-model="vcta.contact.name"
            class="bg-white outline-none rounded p-2 shadow border mt-2"
          />
        </div>
        <div class="w-full flex flex-col">
          <label class="text-xs uppercase mb-2">Email address:</label>
          <input
            readonly
            v-model="vcta.contact.email"
            class="bg-white outline-none rounded p-2 shadow border mt-2"
          />
        </div>
      </div>
      <div class="w-full flex flex-col mb-">
        <div class="w-full flex flex-col mb-5 mt-10">
          <label class="text-xs uppercase mb-2">Contact number</label>
          <input
            readonly
            v-model="vcta.contact.number"
            class="bg-white outline-none rounded p-2 shadow border mt-2"
          />
        </div>
        <div class="w-full flex flex-col mb-5">
          <label class="text-xs uppercase mb-2">Website:</label>
          <input
            readonly
            v-model="vcta.contact.website"
            class="bg-white outline-none rounded p-2 shadow border mt-2"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoBrandingCallToAction',

  props: ['value'],

  computed: {
    vcta: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>
/* Margin right of 5px is defined globally, wont change so resetting here instead so we can have a white background.*/
input[type="checkbox"]:not(:checked) + label::before {
  margin-right: 1em;
  background-color: #fff;
}
</style>
